import { render } from "./CompanyInformationAddressList.vue?vue&type=template&id=18d76d21&scoped=true"
import script from "./CompanyInformationAddressList.vue?vue&type=script&lang=js"
export * from "./CompanyInformationAddressList.vue?vue&type=script&lang=js"

import "./CompanyInformationAddressList.vue?vue&type=style&index=0&id=18d76d21&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d76d21"]])

export default __exports__